import styled from 'styled-components';
import Button from 'components/Button';

export const TeamCreationContainer = styled.div`
    z-index: 1;
    width: 100vw;
    padding-bottom: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #D6E1EF;
    padding-top: 25px;
    @media only screen and (max-width: 768px) {
        padding-top: 25px;
        padding-bottom: 25px; 
    }
`;

export const TCImage = styled.img`
    max-width: 100%;
`;

export const HeadTitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 5px;
`;

export const Title = styled.h1`
    font-family: Khula;
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        border-bottom: 0px solid transparent;
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const Description = styled.h3`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    color: #D6E1EF;
    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        color: #D6E1EF;
    }
`;

export const CallToAction = styled(Button)`
    margin-top: 50px;
    @media only screen and (max-width: 768px) {
        margin-top: 25px;
    }
`;

export const ContainerListDesktop = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

export const ContainerListPhone = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    @media only screen and (min-width: 768px) {
        display: none;
    }
`;
